import type {
  UiState,
  UiStateKeys,
  NonEmptyArray,
} from '../types';

type KeyOrKeys = UiStateKeys | NonEmptyArray<UiStateKeys>;

type GetUiStateReturnType<T extends KeyOrKeys> = T extends readonly UiStateKeys[]
  ? { [K in T[number]]: UiState[K] }
  : T extends UiStateKeys
  ? UiState[T]
  : never;

export function getUiState<T extends KeyOrKeys>(keyOrKeys: T) {
  return <U extends UiState>({ ui }: { ui: U }): GetUiStateReturnType<T> => {
    if (Array.isArray(keyOrKeys)) {
      return keyOrKeys.reduce(
        (acc, key) => {
          acc[key] = ui[key];
          return acc;
        },
        {} as Record<UiStateKeys, any>,
      ) as GetUiStateReturnType<T>;
    }
    return ui[keyOrKeys as UiStateKeys] as GetUiStateReturnType<T>;
  }
}
